import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { BUTTON_LOADING_CIRCLE } from 'common/utils/constants';
import HeatmapDiagRasterConfigWarningSign from './HeatmapDiagRasterConfigWarningSign';
import ConfigParamsSettingsTable from 'components/features/TwoHopAlignment/ConfigParamSettingsTable/ConfigParamSettingsTable';
import { useDispatch, useSelector } from 'react-redux';
import { doGetRasterSettings } from 'redux/actions';
import './HeatmapDiagRasterConfigScreen.css';
import { isObjectEmpty } from 'common/utils/helpers';
import CommissionErrorBox from 'components/features/Commissioning/CommissionErrorBox/CommissionErrorBox';

const HeatmapDiagRasterConfigScreen = (props) => {
  const dispatch = useDispatch();
  const getRasterSettingsStatus = useSelector((store) => store.statuses['GET-RasterSettings']);
  const rasterSettings = useSelector((store) => store.data.rasterSettings || {});
  const [getSettingsErrorCode, setGetSettingsErrorCode] = useState(null);

  useEffect(() => {
    const cb_success = (res) => {
      res.settings?.polarization && props.setSelectedPolarization(res.settings.polarization);
      props.setLocalSettings(res.settings);
    };
    const cb_failed = (error) => {
      setGetSettingsErrorCode(error.message);
    };
    isObjectEmpty(rasterSettings) && dispatch(doGetRasterSettings(cb_success, cb_failed));
  }, []);

  // const handlePolarizationSelection = (polarization) => {
  //   let newPolarizationSelections = JSON.parse(JSON.stringify(props.polarizationSelections));
  //   let newSelected = !newPolarizationSelections[polarization].selected;
  //   Object.keys(newPolarizationSelections).forEach((pol) => {
  //     if (pol === polarization) {
  //       newPolarizationSelections[pol].selected = newSelected;
  //       props.setActivePolarization(newSelected ? newPolarizationSelections[pol].name : null);
  //     } else {
  //       newPolarizationSelections[pol].selected = false;
  //     }
  //   });
  //   props.setSelectedPolarization(newSelected ? polarization : null);
  //   props.setPolarizationSelections(newPolarizationSelections);
  // };

  const handleSettingsChange = (data = [], errors = []) => {
    props.setLocalSettings(data);
    props.setInputErrors(errors);
    if (data.length) {
      for (let param of data) {
        if (param.name === 'polarization') {
          param.current && props.setSelectedPolarization(param.current.toLowerCase());
          break;
        }
      }
    }
  };

  const hasInputErrors = props.inputErrors && props.inputErrors.filter((error) => error).length > 0;

  let overlay = null;
  if (getSettingsErrorCode) {
    overlay = (
      <CommissionErrorBox
        title={`Get Raster Settings Error: ${getSettingsErrorCode}`}
        message={'Something went wrong. Please try it again later.'}
        onClose={props.onClose}
      />
    );
  }

  return (
    <div id="HeatmapDiagRasterConfigScreen_Container" className="HeatmapDiagRasterConfigScreen_Container">
      {overlay}
      <div id="HeatmapDiagRasterConfigScreen_TopContainer" className="HeatmapDiagRasterConfigScreen_TopContainer">
        <div id="HeatmapDiagRasterConfigScreen_HeaderText" className="HeatmapDiagRasterConfigScreen_HeaderText">
          Diagnostic Raster
        </div>
        <HeatmapDiagRasterConfigWarningSign />
        {/* <HeatmapDiagRasterSetTimeoutConfig
          timeoutMinute={props.timeoutMinute}
          setTimeoutMinute={props.setTimeoutMinute}
          isFetching={props.isFetching}
        />
        <HeatmapDiagRasterSetPolarizationConfig
          polarizationSelections={props.polarizationSelections}
          handlePolarizationSelection={handlePolarizationSelection}
        /> */}
        {/* <HeatmapDiagRasterSetRasterScanValuesConfig
          stepsDegree={props.stepsDegree}
          minMaxRange={props.minMaxRange}
          setStepsDegree={props.setStepsDegree}
          setMinMaxRange={props.setMinMaxRange}
          isFetching={props.isFetching}
        />
        <HeatmapDiagRasterSetMaxRasterGainConfig
          isFetching={props.isFetching}
          setMaxRasterGain={props.setMaxRasterGain}
          maxRasterGain={props.maxRasterGain}
        /> */}
        <div className="HeatmapDiagRasterConfigScreen_SettingsTableContainer">
          <div className="HeatmapDiagRasterConfigScreen_SettingsTable_Header">
            <div className="HeatmapDiagRasterConfigScreen_SettingsTable_Header_Text">
              {rasterSettings?.title || 'Parameters'}
            </div>
          </div>
          <ConfigParamsSettingsTable
            requestStatus={getRasterSettingsStatus}
            widths={{
              settings_table_device_col_id: 140,
              settings_table_curr_value_col_id: 110,
              settings_table_default_value_col_id: 110,
              settings_table_new_value_col_id: 210
            }}
            minRows={9}
            itemName={'Config'}
            data={rasterSettings}
            // onApply={(data) => handleOnApply(data)}
            setLocalSettings={props.setLocalSettings}
            action={handleSettingsChange}
            hideSaveBtn={true}
          />
        </div>
      </div>
      <div id="HeatmapDiagRasterConfigScreen_BottomContainer" className="HeatmapDiagRasterConfigScreen_BottomContainer">
        <button
          id="HeatmapDiagRasterConfigScreen_Bottom_CancelButton"
          className={classnames({
            HeatmapDiagRasterConfigScreen_Bottom_CancelButton: true
            // HeatmapDiagRasterConfigScreen_Bottom_CancelButton_Disabled: props.isFetching
          })}
          onClick={() => {
            props.onClose();
          }}
        >
          Cancel
        </button>

        <button
          type="submit"
          disabled={props.isFetching || hasInputErrors}
          id="HeatmapDiagRasterConfigScreen_Bottom_ActionButton"
          className={classnames({
            HeatmapDiagRasterConfigScreen_Bottom_ActionButton: true,
            HeatmapDiagRasterConfigScreen_Bottom_ActionButton_Disabled: props.isFetching || hasInputErrors
            // ||
            // props.timeoutMinute < 5 ||
            // props.timeoutMinute > 15 ||
            // props.activePolarization == null
          })}
          onClick={() => {
            !props.isFetching && !hasInputErrors && props.retrieveDiagRasterAction();
          }}
        >
          {props.isFetching ? BUTTON_LOADING_CIRCLE : 'Run Diagnostic Raster'}
        </button>
      </div>
    </div>
  );
};

export default React.memo(HeatmapDiagRasterConfigScreen);
